import Toastr from 'toastr';
import $ from "jquery";

export class Toast {
    public static Display(message: string, title: string = null, type: string = 'success', options?: { closeButton: boolean, progressBar: boolean, showDuration: number, hideDuration: number, timeOut: number, extendedTimeOut: number, showMethod: string, hideMethod: string }) {
        // Set defaults
        var defaultOpts = {
            closeButton: true,
            progressBar: true,
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000,
            showMethod: "slideLeft",
            hideMethod: "fadeOut"
        }
        // Apply defaults to any options not provided
        if (typeof options != "undefined") {
            options.closeButton = options.closeButton != null ? options.closeButton : defaultOpts.closeButton;
            options.progressBar = options.progressBar != null ? options.progressBar : defaultOpts.progressBar;
            options.showDuration = options.showDuration || defaultOpts.showDuration;
            options.hideDuration = options.hideDuration || defaultOpts.hideDuration;
            options.timeOut = options.timeOut || defaultOpts.timeOut;
            options.extendedTimeOut = options.extendedTimeOut || defaultOpts.extendedTimeOut;
            options.showMethod = options.showMethod || defaultOpts.showMethod;
            options.hideMethod = options.hideMethod || defaultOpts.hideMethod;
        } else {
            options = defaultOpts;
        }

        // Add slideLeft function to jQuery if not defined
            $.fn.extend({
                slideLeft: function () {
                    return this.each(function () {
                        $(this).show().animate({ 'right': '30px' });
                    });
                }
            });
        // Display Toast. Yay Toast!
        Toastr[type](message, title, options);
    }

    // Clear toasts
    public static Clear() {
        Toastr.clear();
    }

    private static PENDING_TOAST_KEY = 'pendingToast';

    // Store a toast message in sessionStorage to display after page navigation
    public static SetPendingToast(message: string, title: string = null, type: string = 'info') {
        if (typeof window !== 'undefined' && window.sessionStorage) {
            sessionStorage.setItem(Toast.PENDING_TOAST_KEY, JSON.stringify({ message, title, type }));
        }
    }

    // Display a pending toast from sessionStorage (if any) and clear it
    public static DisplayPendingToast() {
        if (typeof window === 'undefined' || !window.sessionStorage) return;
        var pending = sessionStorage.getItem(Toast.PENDING_TOAST_KEY);
        if (pending) {
            sessionStorage.removeItem(Toast.PENDING_TOAST_KEY);
            try {
                var data = JSON.parse(pending);
                Toast.Display(data.message, data.title, data.type || 'info', {
                    closeButton: true,
                    progressBar: true,
                    showDuration: 300,
                    hideDuration: 1000,
                    timeOut: 15000,
                    extendedTimeOut: 5000,
                    showMethod: "slideLeft",
                    hideMethod: "fadeOut"
                });
            } catch (e) {
                // Ignore malformed pending toast
            }
        }
    }
}